import { Box, Grid } from '@mui/material';
import {
  AdminPerformanceMetrics,
  ResponseTimeDataPoint,
  RequestRateDataPoint,
  QueryDurationDataPoint,
} from '../../../types/admin';
import RefreshButton from './shared/RefreshButton';
import AdminMetricCard from '../shared/AdminMetricCard';
import ResponseTimeChart from './performance/ResponseTimeChart';
import RequestRateChart from './performance/RequestRateChart';
import DatabaseQueryChart from './performance/DatabaseQueryChart';

interface PerformanceTabProps {
  performance: AdminPerformanceMetrics;
  responseTimeHistory: ResponseTimeDataPoint[];
  requestRateHistory: RequestRateDataPoint[];
  queryDurationDistribution: QueryDurationDataPoint[];
  loading?: boolean;
  lastUpdated: string;
  onRefresh: () => void;
}

export default function PerformanceTab({
  performance,
  responseTimeHistory,
  requestRateHistory,
  queryDurationDistribution,
  loading,
  lastUpdated,
  onRefresh,
}: PerformanceTabProps) {
  return (
    <Box>
      {/* Header with Refresh Button */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
        <RefreshButton onRefresh={onRefresh} lastUpdated={lastUpdated} loading={loading} />
      </Box>

      {/* Performance Metrics */}
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <AdminMetricCard title="API p95" value={`${performance.api_p95}ms`} loading={loading} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <AdminMetricCard title="Request Rate" value={`${performance.request_rate}/min`} loading={loading} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <AdminMetricCard title="DB Query Time (avg)" value={`${performance.db_query_time_avg}ms`} loading={loading} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <AdminMetricCard title="Worker CPU Time" value={`${performance.worker_cpu_time}ms`} loading={loading} />
        </Grid>
      </Grid>

      {/* Charts */}
      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item xs={12} lg={6}>
          <ResponseTimeChart data={responseTimeHistory} loading={loading} />
        </Grid>
        <Grid item xs={12} lg={6}>
          <RequestRateChart data={requestRateHistory} loading={loading} />
        </Grid>
        <Grid item xs={12}>
          <DatabaseQueryChart data={queryDurationDistribution} loading={loading} />
        </Grid>
      </Grid>
    </Box>
  );
}
